import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DeliveryNotesService } from 'src/app/services/sales-management/delivery-notes.service';
import { GlobalService } from 'src/app/services/shared/global.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

 // Declare jQuery to avoid TypeScript compilation errors
declare var $: any;

@Component({
  selector: 'app-delivery-notes',
  templateUrl: './delivery-notes.component.html',
  styleUrls: ['./delivery-notes.component.css']
})
export class DeliveryNotesComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public warningMessage: string | null = null;
  public popupErrorMessage:string|null = null;
  public popupWarningMessage:string|null = null;
  delivery_notes: any[] = [];
  public userPermissions: string[] = [];
  searchText: string = '';
  public isInProgress: boolean = false;
  public isProcessing: boolean = false;
  submitted: boolean = false;
  form!: FormGroup;
  attachSignedDeliveryNoteForm!: FormGroup;
  locations: any[] = [];
  bills_of_lading: any[] = [];
  rowCount: number=0;
  public delivery_id:string='';
  public vehicle_id:string='';
  public customerData:any;
  signed_delivery_note_attachment: any;
  signedDeliveryNoteFileName: string="Choose a PDF or an image file";
  @ViewChild('UpdateCustomerInfoModal') modalElement!: ElementRef;
  @ViewChild('AttachSignedDeliveryNoteModal') uploadModalElement!: ElementRef;

  salesRepForm!: FormGroup;
  salesReps: any[] = [];
  selectedSalesRep!: string;
  deliveryNoteId: string='';

  constructor(
    private deliveryNotesService:DeliveryNotesService,
    private globalService: GlobalService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router
  ){
    this.form = this.formBuilder.group({
      customer_name: ['', Validators.required],
      id_no: ['', Validators.required],
      phone_no: ['', Validators.required],
      customer_address: ['', Validators.required]
    });

    this.attachSignedDeliveryNoteForm = this.formBuilder.group({
      signed_delivery_note_attachment: [null, Validators.required],
    });

    this.salesRepForm = this.formBuilder.group({

    });
  }

  ngOnInit(): void {
    this.isInProgress=true;
    this.userPermissions=this.authService.getPermissions();
    this.deliveryNotesList();
  }

  deliveryNotesList():void{
    this.deliveryNotesService.getDeliveryNotes()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.delivery_notes = response.data;
          this.rowCount = this.delivery_notes.length;
          this.isInProgress=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isInProgress=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }

  openModal(delivery_id:string){
    this.delivery_id=delivery_id;
    this.popupErrorMessage=null;
    this.popupWarningMessage=null;

    //Fetch customer info
    this.deliveryNotesService.getCustomerInfo(this.delivery_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please try again!";
        }else{
          this.customerData = response;
          if(this.customerData.status==='no_data' || this.customerData.status.length===0){
            this.errorMessage=this.customerData.message;
          }else{
            //Open modal
            if (this.modalElement) {
              (<any>$(this.modalElement.nativeElement)).modal('show');
            }
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  closeModal():void {
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('hide');
    }
  }

  handleSubmit(){
    this.submitted = true;
    this.isProcessing=true;

    if (this.form.valid) {
      this.deliveryNotesService.updateCustomerInfo(this.form.value.customer_name,this.form.value.id_no,this.form.value.phone_no,this.form.value.customer_address,this.delivery_id)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isProcessing=false;
            this.globalService.setGlobalSuccessMessage(response.message);
            this.closeModal();
           //Refresh list
           this.isInProgress=true;
           this.deliveryNotesList();
          }else if(response.status==='error'){
            this.submitted = false;
            this.isProcessing=false;
            this.popupErrorMessage=response.message;
          }else if(response.status==='warning'){
            this.submitted = false;
            this.isProcessing=false;
            this.popupWarningMessage=response.message;
          }else{
            this.submitted = false;
            this.isProcessing=false;
            this.popupErrorMessage=response.message;
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing=false;
          this.popupErrorMessage=error;
        }
      });
    }else{
      this.isProcessing=false;
    }
  }

  openUploadModal(delivery_id:string,vehicle_id:string){
    this.delivery_id=delivery_id;
    this.vehicle_id=vehicle_id;
    this.popupErrorMessage=null;
    this.popupWarningMessage=null;

    //Open modal
    if (this.uploadModalElement) {
      (<any>$(this.uploadModalElement.nativeElement)).modal('show');
    }
  }

  closeUploadModal():void {
    if (this.uploadModalElement) {
      (<any>$(this.uploadModalElement.nativeElement)).modal('hide');
    }
  }

   /**
   * Handle selectd file
   * @param event
   */
   onDeliveryNoteFileSelected(event: any) {
    //Show selected file
    const fileInput = event.target as HTMLInputElement;
    this.signedDeliveryNoteFileName = fileInput.files?.[0]?.name ?? 'Choose a PDF or an image file';

    //Prepare file for upload
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.signed_delivery_note_attachment = file
    }
  }

  handleUpload(){
    this.submitted = true;
    this.isProcessing=true;

    if (this.attachSignedDeliveryNoteForm.valid) {
      this.deliveryNotesService.uploadSignedDeliveryNote(this.delivery_id,this.vehicle_id,this.signed_delivery_note_attachment)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isProcessing=false;
            this.signed_delivery_note_attachment=null;
            this.signedDeliveryNoteFileName ="Choose a PDF or an image file";
            this.globalService.setGlobalSuccessMessage(response.message);
            this.closeUploadModal();
           //Refresh list
           this.isInProgress=true;
           this.deliveryNotesList();
          }else if(response.status==='error'){
            this.submitted = false;
            this.isProcessing=false;
            this.popupErrorMessage=response.message;
          }else if(response.status==='warning'){
            this.submitted = false;
            this.isProcessing=false;
            this.popupWarningMessage=response.message;
          }else{
            this.submitted = false;
            this.isProcessing=false;
            this.popupErrorMessage=response.message;
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing=false;
          this.popupErrorMessage=error;
        }
      });
    }else{
      this.isProcessing=false;
    }
  }

  openAddSalesTargetModal(delivery_uuid:string): void{
    this.deliveryNotesService.getSalesReps().subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isInProgress = false;
          this.deliveryNoteId = delivery_uuid;
          this.salesReps = response.data
          $('#addSalesRepModal').modal('show');
        }else{
          this.isInProgress = false;
          this.errorMessage = response.message;
        }
      },
      error: (error) => {
        this.isInProgress = false;
        this.errorMessage = error;
      }
    });
  }

  addSalesRep(): void{
    this.submitted = true;
    this.isProcessing = true;

    if(this.selectedSalesRep==null || this.selectedSalesRep==undefined || this.selectedSalesRep==''){
      this.errorMessage="Please select a sales rep. to proceed!";
      this.toastr.error(this.errorMessage, 'Error!');
      this.isProcessing = false;
    }else{
      this.deliveryNotesService.addSalesRep(this.deliveryNoteId,this.selectedSalesRep)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isProcessing = false;
            this.errorMessage=null;
            this.toastr.success(response.message, 'Success!');
            this.selectedSalesRep = '';
            this.form.reset();
            $('#addSalesRepModal').modal('hide');
            this.router.navigate(['sales/print-delivery-note',this.deliveryNoteId]);
          }else{
            this.toastr.error(response.message, 'Error!');
            this.submitted = false;
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.errorMessage=error;
          this.toastr.error(error, 'Error!');
          this.submitted = false;
          this.isProcessing = false;
        }
      });
    }
  }
}
